import { RouteComponentProps, Route, Switch } from 'react-router-dom';

import * as path from '@urls';
import { ProfileLayout } from '@layouts/ProfileLayout';
import { ProfilePage } from '@pages/profile/ProfilePage';
import { ProfileReviewsPage } from '@pages/profile/ProfileReviewsPage';
import { ProfileAboutPage } from '@pages/profile/ProfileAboutPage';
import { ProfilePostsPage } from '@pages/profile/ProfilePostsPage';

// eslint-disable-next-line react/display-name
export default ({ match }: RouteComponentProps<{ username: string }>) => (
  <ProfileLayout username={match.params.username}>
    <Switch>
      <Route
        path={path.publicMemberProfile}
        component={ProfilePage}
        exact={true}
      />
      <Route
        path={path.memberReviews}
        component={ProfileReviewsPage}
      />
      <Route
        path={path.aboutMemberProfile}
        component={ProfileAboutPage}
      />
      <Route
        path={path.memberSocialPosts}
        component={ProfilePostsPage}
      />
    </Switch>
  </ProfileLayout>
);
